exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_from_CreateLeadForm-css_6nf {\r\n  padding: 32px 64px;\r\n}\r\n\r\n.form_from_CreateLeadForm-css_2q2 {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: distribute;\r\n      justify-content: space-around;\r\n  -ms-flex-line-pack: start;\r\n      align-content: flex-start;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: row;\r\n          flex-direction: row;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n  position: relative;\r\n}\r\n\r\n.saving_from_CreateLeadForm-css_2Lb {\r\n  padding-top: 12px;\r\n  text-align: right;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_CreateLeadForm-css_6nf",
	"form": "form_from_CreateLeadForm-css_2q2",
	"saving": "saving_from_CreateLeadForm-css_2Lb"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/createlead/CreateLeadForm.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/createlead/CreateLeadForm.css
// module chunks = 0